import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CustomEase } from "gsap/CustomEase";
import { ScrollSmoother } from "gsap/ScrollSmoother";

gsap.registerPlugin(ScrollTrigger, CustomEase, ScrollSmoother);

if (!ScrollTrigger.isTouch) {
  ScrollSmoother.create({
    normalizeScroll: true,
    smoothTouch: false,
  });
  gsap.set("#smooth-content", { willChange: "transform" });
}

import observe from "../js_modules/_observer.mjs";

const list_elements = document.querySelectorAll(".realisations-list__item");
let previousFrameImage;
let secondPreviousFrameImage;

function initializeFrame() {
  let frame_scroll_end =
    document.querySelector(".realisations-list").offsetHeight -
    document.querySelector(".page-realisations__image-frame-outer")
      .offsetHeight;

  let frame_timeline = gsap.timeline({
    scrollTrigger: {
      trigger: ".realisations-list",
      pin: ".page-realisations__image-frame-outer",
      start: "top top+=124",
      end: () =>
        "+=" +
        Math.max(
          document.querySelector(".realisations-list").offsetHeight -
            document.querySelector(".page-realisations__image-frame-outer")
              .offsetHeight,
        ),
    },
  });

  if (list_elements) {
    list_elements.forEach((element) => {
      gsap.to(element, {
        scrollTrigger: {
          trigger: element,
          start: "top center+=50px",
          end: "bottom center+=50px",
          onEnter: () => {
            if (!desktopMQ.matches) return;
            element.classList.add("active");
            changeFramedImage(element);
          },
          onEnterBack: () => {
            if (!desktopMQ.matches) return;
            element.classList.add("active");
            changeFramedImage(element);
          },
          onLeave: () => {
            element.classList.remove("active");
          },
          onLeaveBack: () => {
            element.classList.remove("active");
          },
        },
      });
    });
  }

  const rows = document.querySelectorAll(".realisations-list__item");

  changeFramedImage(rows[0]);

  rows.forEach((row) => {
    row.addEventListener("mouseenter", (e) => {
      changeFramedImage(row);
    });
  });
}

const frameTopIndex = document.querySelector(
  ".page-realisations__image-frame-top-index",
);

function changeFramedImage(row) {
  let index = row.dataset.projectId;
  if (frameTopIndex) frameTopIndex.textContent = String(index).padStart(2, "0");
  let target = `.realisations-list__image-frame-slide[data-image-id="${index}"]`;
  if (
    !previousFrameImage ||
    (previousFrameImage && target !== previousFrameImage)
  ) {
    if (secondPreviousFrameImage) {
      gsap.set(secondPreviousFrameImage, {
        opacity: 0,
        overwrite: true,
        immediateRender: true,
      });
    }
    if (previousFrameImage) {
      gsap.set(previousFrameImage, {
        zIndex: 0,
        opacity: 1,
        overwrite: true,
        immediateRender: true,
      });
      gsap.set(`${previousFrameImage} .realisations-list__image-frame-bottom`, {
        opacity: 0,
        overwrite: true,
        immediateRender: true,
      });
    }
    gsap.set(`${target} .realisations-list__image-frame-bottom`, {
      opacity: 1,
      overwrite: true,
      immediateRender: true,
    });
    gsap.fromTo(
      target,
      { opacity: 0 },
      {
        zIndex: 2,
        opacity: 1,
        duration: 0.5,
        overwrite: true,
        immediateRender: true,
      },
    );
    gsap.fromTo(
      `${target} .realisations-list__image-frame-image`,
      { scale: 1.1 },
      {
        scale: 1,
        duration: 0.5,
        overwrite: true,
        immediateRender: true,
      },
    );
    if (previousFrameImage) {
      secondPreviousFrameImage = previousFrameImage;
    }
    previousFrameImage = target;
  }
}

let frameInitialized = false;
const desktopMQ = window.matchMedia("(min-width: 1221px)");

function maybeInitializeFrame(matches) {
  if (matches && !frameInitialized) {
    frameInitialized = true;
    initializeFrame();
  }
}

maybeInitializeFrame(desktopMQ.matches);
desktopMQ.addEventListener("change", (e) => maybeInitializeFrame(e.matches));

observe();
